import React from "react";
import cn from "classnames";

interface Props {
  username: string;
  avatar_url: string;
  side: "heads" | "tails";
  winner: boolean;
}

import styles from "./AvatarCircle.module.scss";
export default function AvatarCircle(props: Props): JSX.Element {
  return (
    <div
      className={cn(styles.container, {
        [styles.duel]: props.side == "heads" || false,
        [styles.ana]: props.side == "tails" || false,
        [styles.winner]: props.winner || false,
      })}
    >
      {props.avatar_url && (
        <img
          src={props.avatar_url}
          className={styles.avatar}
          alt={`${props.username} profile picture`}
        />
      )}
    </div>
  );
}
